<div class="navbar">
  <ng-template ngFor let-item [ngForOf]="routes" let-i="index">
    <ng-container *ngIf="role && !item.hidden && item.roles.indexOf(role) !== -1" [ngTemplateOutlet]="item.items ? withChildren : withoutChildren"
                  [ngTemplateOutletContext]="{item:item}"></ng-container>

    <ng-template #withChildren let-item="item">
      <div class="dropdown" [class.route-active]="isChildrenActivated(item.items)">
        <a style="padding-top: 16px !important;" [routerLink]="item.path"  class="dropbtn dx-item dx-menu-item dx-menu-item-has-text">{{item.text}}
        </a>
        <div class="dropdown-content dx-card">
          <a class="dx-item dx-menu-item dx-menu-item-has-text" *ngFor="let route of filter(item.items)" [routerLink]="route.path" [target]="RouteTarget(route)">{{route.text}}</a>
        </div>
      </div>
    </ng-template>

    <ng-template #withoutChildren let-item="item">
      <a class="dx-item dx-menu-item dx-menu-item-has-text" style="padding-top: 16px !important;" [routerLink]="item.path" >{{item.text}}</a>
    </ng-template>
  </ng-template>
</div>
